import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import { getAuth } from 'firebase/auth'
import { getMessaging } from 'firebase/messaging'
import 'firebaseui/dist/firebaseui.css'

const firebaseConfig = {
  apiKey: 'AIzaSyAlbEz-b_vLcNL_QpZab-W0Evf4l4iBwok',
  authDomain: 'drawtalk-7f226.firebaseapp.com',
  projectId: 'drawtalk-7f226',
  storageBucket: 'drawtalk-7f226.appspot.com',
  messagingSenderId: '234515095723',
  appId: '1:234515095723:web:da481964f17fc9c94117ee',
  measurementId: 'G-V6Z20WR23W'
}

const app = initializeApp(firebaseConfig)

export const analytics = getAnalytics(app)
export const authentication = getAuth(app)
let _messaging: ReturnType<typeof getMessaging> | null = null
try { _messaging = getMessaging(app) } catch {}
export const messaging = _messaging

export default app
